module.exports = __webpack_public_path__ + "static/media/logo.bf1905d2.svg";